import { Injectable } from '@angular/core';
import { AngularFireList, AngularFireDatabase } from 'angularfire2/database';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoticesService {
  noticeList: AngularFireList<any>;
  gotNotice = false;
  noticeChange = new BehaviorSubject<any[]>([]);
  notice: any[] = [];
  noticeItemChnage = new BehaviorSubject<any>(null);
  sub:Subscription;

  constructor(private firebase: AngularFireDatabase) {}

  getNoticeList() {
    if (!this.gotNotice) {
      this.noticeList = this.firebase.list('notice');
      this.gotNotice = true;
    }
    this.setNotice();
  }

  setNotice() {
    this.noticeList.snapshotChanges().subscribe((list) => {
      this.notice = list.map((item) => {
        return {
          $key: item.key,
          ...item.payload.val(),
        };
      });
      this.notice = this.notice.reverse();
      this.noticeChange.next(this.notice);
    });
  }

  getNotice() {
    this.noticeChange.next(this.notice);
  }

  getNotices() {
    return this.notice;
  }

  getNoticeSearchList(id: string) {
    if (!this.gotNotice) {
      this.noticeList = this.firebase.list('notice');
      this.sub = this.noticeList.snapshotChanges().subscribe((list) => {
        this.notice = list.map((item) => {
          return {
            $key: item.key,
            ...item.payload.val(),
          };
        });
        this.notice = this.notice.reverse();
        let data = this.notice.find(
          (data) => data.$key === id || data.urlRoute === id
        );
        if (data) {
          this.noticeItemChnage.next(data);
        } else {
          this.noticeItemChnage.next(null);
        }
      });
    }
  }

  searchNotice(id: string) {
    let data = this.notice.find(
      (data) => data.$key === id || data.urlRoute === id
    );
    if (data) {
      this.noticeItemChnage.next(data);
    } else {
      this.noticeItemChnage.next(null);
    }
  }
}
